module.exports = __webpack_public_path__ + "static/SouthKorea-d827723e21d3ca8ae1902d531837b5ed.svg";